import "react";
import "./auth-service-tools177.js";
import { createOptionalContext } from "./auth-service-tools178.js";
const [PillGroupProvider, usePillGroupContext] = createOptionalContext();
export { PillGroupProvider, usePillGroupContext };